import {push} from 'connected-react-router'
import {
    FORM_ERROR,
    FORM_SUCCESS,
    GET_CLIENT,
    LOAD_DATA,
    QUESTION_ANSWER,
    QUESTION_VOTE,
    SEND_FORM,
    VOTE
} from "../constants";


const getAPIURL = () => {
	const API_URL = 'api/v1/';
	const PROJECT_NAME = 'hodnoceni_aitom_cz';
	let url;
	
	switch(window.location.host) {
		case 'localhost:3000':
			url = `//localhost/${PROJECT_NAME}/${API_URL}`;
			break;
		case 'localhost':
		case 'test.web02-aitom.cz':
			url = `//${window.location.host}/${PROJECT_NAME}/${API_URL}`;
			break;
		
		default:
			url = `//${window.location.host}/${API_URL}`;
			
	}
	
	return url;
}

export const getQuestions = (clientId) => {
    return dispatch => {
        dispatch({
            type: LOAD_DATA,
        });

        fetch(`${getAPIURL()}evaluation/${clientId}`)
            .then(res => res.json())
            .then(
                data => dispatch({type: GET_CLIENT, data}),
                err => dispatch(push(`${process.env.PUBLIC_URL}/`))
            );
    }

}

export const voteMark = (mark, hash) => {
    return dispatch => {
        dispatch({
            type: VOTE,
            mark: mark
        });

        dispatch(push(`${process.env.PUBLIC_URL}/${hash}/${mark}`))

        fetch(`${getAPIURL()}evaluation/${hash}`, {
            method: 'put',
            body: JSON.stringify({mark: mark})
        })
            .then(res => res.json())
            .then((data) => {

        });
    }
};

export const voteQuestionMark = (i, id, mark) => {
    return dispatch => {
        dispatch({
            type: QUESTION_VOTE,
            i: i,
            mark: mark,
        });

        fetch(`${getAPIURL()}question/${id}`, {
                method: 'put',
                body: JSON.stringify({mark: mark})
        }).then(function (response) {
                return response.json();
        }).then(function (data) {

        });
    }
};

export const changeQuestionAnswer = (i, id, answer) => {
    return dispatch => {
        dispatch({
            type: QUESTION_ANSWER,
            i: i,
            answer: answer,
        });
    }
};

export const voteQuestionAnswer = (i, id, answer) => {
    return dispatch => {
        dispatch({
            type: QUESTION_ANSWER,
            i: i,
            answer: answer,
        });

        fetch(`${getAPIURL()}question/${id}`, {
                method: 'put',
                body: JSON.stringify({"answer": answer})
        }).then(function (response) {
                return response.json();
        }).then(function (data) {

        });
    }
};

export const sendForm = (hash) => {
    return dispatch => {
        dispatch({
            type: SEND_FORM,
        });

        fetch(`${getAPIURL()}evaluation/${hash}`, {
                method: 'put',
                body: JSON.stringify({"state": "filled"})
        }).then(function (response) {

                if (response.status !== 200) {
                    dispatch({
                        type: FORM_ERROR,
                    });
                    dispatch(push(`${process.env.PUBLIC_URL}/${hash}/chyba`));
                    return;
                }
                response.json().then(function (data) {
                    dispatch({
                        type: FORM_SUCCESS,
                    });
                    dispatch(push(`${process.env.PUBLIC_URL}/${hash}/odeslano`));
                });
        });

    };
};


// WEBPACK FOOTER //
// ./src/thunks/index.js